import { render, staticRenderFns } from "./CustomUrl.vue?vue&type=template&id=12ed8fca"
import script from "./CustomUrl.vue?vue&type=script&lang=js"
export * from "./CustomUrl.vue?vue&type=script&lang=js"
import style0 from "./CustomUrl.vue?vue&type=style&index=0&id=12ed8fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports